import React from 'react';
import { LandingTopWidget } from '../../organisms/landing';
import { SettingsWrapper } from '../../organisms/settings/SettingsWrapper';
import { SettingsAccessControl } from '../../organisms/settings/SettingsAccessControl';
import { AuditWorkflowMain } from '../../organisms/settings/auditWorkflow/AuditWorkflowMain';

/**
 * presentations/components/pages/settings/AuditWorkflowPage.tsx
 */
const AuditWorkflowPage: React.FC = () => (
  <SettingsAccessControl allowedRoles='systemAdmin'>
    <div className='h-full flex flex-col bg-white'>
      <LandingTopWidget title='Settings' hideSearchBar hideUploadButton />

      <SettingsWrapper>
        <AuditWorkflowMain />
      </SettingsWrapper>
    </div>
  </SettingsAccessControl>
);

export default AuditWorkflowPage;
